module.exports = __webpack_public_path__ + "img/gaia.650e4512.jpeg";